import React from "react";
import { Card, FormInput, FormSelect } from "ui-kit-ck-consultant";
import { Row, Col } from "react-flexbox-grid";
import { getCompaniesOptions } from "../../utils/general";

export default class Filters extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    let regions = [];
    let agencies = [];
    let experts = [];

    this.props.folders.forEach((folder) => {
      if (folder.regionName && !regions.includes(folder.regionName)) {
        regions.push(folder.regionName);
      }
      if (folder.agencyName && !agencies.includes(folder.agencyName)) {
        agencies.push(folder.agencyName);
      }
      if (folder.expertName && !experts.includes(folder.expertName)) {
        experts.push(folder.expertName);
      }
    });

    return (
      <>
        <Card title="Filtres" className="mb-10 mb-20-xl">
          <Row>
            <Col xs={12} md={3}>
              <FormInput
                className="mb-20"
                title="N° dossier"
                value={this.props.reference}
                name="reference"
                onChange={this.props.handleInputChange}
              />
            </Col>
            <Col xs={12} md={3}>
              <FormInput
                className="mb-20"
                type="date"
                title="Date de début"
                value={this.props.dateStart}
                name="dateStart"
                onChange={this.props.handleInputChange}
              />
            </Col>
            <Col xs={12} md={3}>
              <FormInput
                className="mb-20"
                type="date"
                title="Date de fin"
                value={this.props.dateEnd}
                name="dateEnd"
                onChange={this.props.handleInputChange}
              />
            </Col>
            <Col xs={12} md={3}>
              <FormInput
                className="mb-20"
                title="Immatriculation"
                value={this.props.licensePlate}
                name="licensePlate"
                onChange={this.props.handleInputChange}
              />
            </Col>
            <Col xs={12} md={3}>
              <FormInput
                className="mb-20"
                title="Client"
                value={this.props.insuredName}
                name="insuredName"
                onChange={this.props.handleInputChange}
              />
            </Col>
            <Col xs={12} md={3}>
              <FormSelect
                className="mb-20"
                title="Compagnie"
                value={this.props.company}
                name="company"
                ignore={true}
                options={[
                  { text: "Toutes les compagnies", value: "DEFAULT" },
                ].concat(getCompaniesOptions())}
                onChange={this.props.handleInputChange}
              />
            </Col>
            <Col xs={12} md={3}>
              <FormSelect
                className="mb-20"
                title="Région"
                value={this.props.region}
                name="region"
                ignore={true}
                options={[
                  { text: "Toutes les régions", value: "DEFAULT" },
                ].concat(
                  regions.map((region) => ({ text: region, value: region }))
                )}
                onChange={this.props.handleInputChange}
              />
            </Col>
            <Col xs={12} md={3}>
              <FormSelect
                className="mb-20"
                title="Agence"
                value={this.props.agency}
                name="agency"
                ignore={true}
                options={[
                  { text: "Toutes les agences", value: "DEFAULT" },
                ].concat(
                  agencies.map((agency) => ({ text: agency, value: agency }))
                )}
                onChange={this.props.handleInputChange}
              />
            </Col>
            <Col xs={12} md={3}>
              <FormSelect
                className="mb-20"
                title="Expert"
                value={this.props.expert}
                name="expert"
                ignore={true}
                options={[
                  { text: "Tous les experts", value: "DEFAULT" },
                ].concat(
                  experts.map((expert) => ({ text: expert, value: expert }))
                )}
                onChange={this.props.handleInputChange}
              />
            </Col>
          </Row>
        </Card>
      </>
    );
  }
}
